import React from 'react';
import { Flex } from 'glints-aries/es';
import {
  ButtonGroup,
  OutlineButton,
  Typography,
  TypographyProps,
} from 'glints-aries/es/@next';
import { Neutral } from 'glints-aries/es/@next/utilities/colors';
import { space24 } from 'glints-aries/es/@next/utilities/spacing';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import useCandidateUrl from '../../../common/hooks/useCandidateUrl';
import { ROUTES } from '../../../common/routes';
import useMarketingTrackingService from '../../../common/tracking/useMarketingTrackingService';
import { getIsLoggedIn } from '../../../selectors/session';
import { useAppDispatch } from '../../../store';
import AppLanguageSwitcher from '../../AppLanguage/AppLanguageSwitcher';
import { toggleSidebar } from '../Actions';
import { trackJobSeekerButtonClick, trackLoginButtonClick } from './tracking';

function RenderJobSeekerButton(
  props: {
    typographyProps?: Omit<TypographyProps, 'children'>;
  } = {}
) {
  const authenticated = useSelector(getIsLoggedIn);
  const candidateUrl = useCandidateUrl();

  const { sendMarketingTrackingEvent } = useMarketingTrackingService();

  return (
    <If condition={!authenticated}>
      <a
        href={candidateUrl}
        onClick={() => {
          trackJobSeekerButtonClick('sidebar');
          sendMarketingTrackingEvent({
            event: 'job_seeker_button_click',
            payload: {
              // eslint-disable-next-line camelcase
              job_seeker_button_source: 'sidebar',
            },
          });
        }}
      >
        <Typography
          {...props.typographyProps}
          variant={props.typographyProps?.variant ?? 'button'}
          color={Neutral.B18}
          style={{
            textTransform: 'uppercase',
          }}
        >
          <FormattedMessage
            id="interactive-job-seeker-navbar"
            defaultMessage="JOB SEEKER"
          />
        </Typography>
      </a>
    </If>
  );
}
function SidebarContent() {
  const dispatch = useAppDispatch();
  const closeSidebar = () => dispatch(toggleSidebar());
  return (
    <Flex flexDirection="column" gap={space24}>
      <Link
        to={`/${ROUTES.login}`}
        onClick={() => {
          trackLoginButtonClick('sidebar');
          closeSidebar();
        }}
      >
        <Typography
          variant="subtitle1"
          style={{
            textTransform: 'uppercase',
            color: Neutral.B18,
          }}
        >
          <FormattedMessage id="interactive-login" defaultMessage="Login" />
        </Typography>
      </Link>
      <RenderJobSeekerButton
        typographyProps={{
          variant: 'subtitle1',
        }}
      />
      <AppLanguageSwitcher hideDivider={true} />
    </Flex>
  );
}
function AuthPageMenuItemContent() {
  return (
    <ButtonGroup
      style={{
        gap: 20,
      }}
    >
      <Link
        to={`/${ROUTES.login}`}
        onClick={() => trackLoginButtonClick('navbar')}
      >
        <OutlineButton>
          <Typography
            variant="button"
            style={{
              textTransform: 'uppercase',
            }}
          >
            <FormattedMessage id="interactive-login" defaultMessage="Login" />
          </Typography>
        </OutlineButton>
      </Link>
      <AppLanguageSwitcher />
    </ButtonGroup>
  );
}

export default Object.assign(
  {},
  {
    NavbarContent: AuthPageMenuItemContent,
    SidebarContent,
  }
);
